import React from 'react';

const HeadingElement = ({ element, isEditorMode }) => {
  const { content } = element;
  const {
    text = 'Heading',
    level = 'h2',
    alignment = 'left'
  } = content || {};

  const Tag = level;

  const style = {
    textAlign: alignment,
    margin: '0.5em 0',
    color: 'var(--color-text)' // Always use theme design token
  };

  return (
    <Tag className="builder-heading" style={style}>
      {text}
    </Tag>
  );
};

export default HeadingElement;
